// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"view-list"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 5H21M3 12H21M3 19H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ViewListIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-list',
    ref,
    icon: element,
  },
));

ViewListIcon.displayName = 'ViewListIcon';

export default ViewListIcon;
